import React, { useEffect, useMemo, useState } from "react";
import WIOSSLoader from "../../../interface/WIOSSLoader";
import { useSearchParams } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { use } from "react";
import { useGetDispatchHistory } from "../hooks/useGetDispatchHistory";
import { dateTime } from "../../../version";
import { DayPicker } from "react-day-picker";
import SumOccupiedByHeight from "./SumOccupiedByHeight";
import { useGetDispatchSpectrum } from "../hooks/useGetDispatchSpectrum";
import WeeklySpectrum from "./WeeklySpectrum";
import PreviewTeaser from "./PreviewTeaser";

const ContainerMain = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding: 1rem;
`;

const StyledHeading = styled.h5`
  color: var(--color-grey-500);
  padding-top: 1em;
  padding-left: 2em;
  margin-bottom: -1rem;
`;

const DrawerLabel = styled.label`
  font-size: 0.8em;
  margin-left: 0.5em;
`;

const Drawer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
  height: 100%;
  width: 100px;
  background: rgba(0, 0, 20, 0.8);
  transform: translateX(${(p) => (p.open ? "0" : "-100%")});
  transition: transform 0.3s ease;
  padding: 1rem;
  padding-top: 4rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const DrawerItem = styled.button`
  background: none;
  border: none;
  color: #fff;
  text-align: left;
  padding: 0.5rem 0;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const MenuButton = styled.button`
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 30;
  font-size: 1.8rem;
  background: none;
  border: none;
  cursor: pointer;
`;

const DataModeWeek = styled.div`
  display: flex;
  position: absolute;
  top: 2rem;
  right: 2rem;  
  justify-content: right;
  z-index: 30;  
`;

const smoothBlink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

const AutoRotateIndicator = styled.div`
  display: flex;
  position: absolute;
  top: 2rem;
  right: 2rem;
  justify-content: right;
  z-index: 30;
  animation: ${smoothBlink} 6s linear infinite;
`;

   

const StyledDateRange = styled.h1`
  font-size: 1em;
  color: var(--color-grey-700);
  align-self: center;
  cursor: pointer; // Make it apparent it is clickable
`;

const PickerModal = styled.div`
  position: fixed;
  top: 5rem; // Adjust this value based on your layout
  right: 1rem;
  transform: translateX(-50%);
  background: var(--backdrop-color);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-div-md);
  padding: 10px;
  border-radius: 8px;
  z-index: 100; // Ensure it is above other content
`;

const CustomPickerStyles = styled.div`
  .rdp-button {
    color: var(--color-gray-400); // Text color for the days
    background-color: transparent;
    border: none;
    font-weight: 100;
    margin: 0.25em;
  }

  .rdp-day_selected,
  .rdp-day_today {
    background-color: #007bff; // Color for selected and today's date
    color: white;
  }
  .rdp-day_today {
    border: 1px solid #00c2ff;
    background-color: transparent;
    color: #e3e9eb;
  }

  .rdp-day_selected {
    background-color: #007bff;
    color: white;
  }

  .rdp-day_range_middle {
    background-color: rgba(0, 123, 255, 0.3);
    color: white;
  }

  .rdp-caption {
    color: var(
      --color-witron-blue
    ); // Custom color for the caption (month and year)
    font-weight: bold;
  }
`;

const ValueModeToggleWrapper = styled.div`
  position: absolute;
  top: 5.9rem;
  right: 2rem;
  z-index: 31;
`;

const ValueModeToggle = styled.label`
  position: relative;
  display: block;
  width: 7.4rem;
  height: 3.6rem;
  cursor: pointer;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  .track {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(
      145deg,
      rgba(10, 15, 25, 0.95),
      rgba(45, 52, 65, 0.95)
    );
    box-shadow:
      inset 0 0.2rem 0.5rem rgba(0, 0, 0, 0.75),
      inset 0 -0.1rem 0.2rem rgba(255, 255, 255, 0.08),
      0 0.3rem 0.8rem rgba(0, 0, 0, 0.45);
    border: 1px solid rgba(255, 255, 255, 0.08);
    overflow: hidden;
  }

  .track::before,
  .track::after {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-weight: 800;
    font-size: 1.3rem;
    line-height: 1;
    z-index: 2;
    transition:
      color 0.25s ease,
      text-shadow 0.25s ease,
      opacity 0.25s ease;
  }

  .track::before {
    content: "#";
    left: 1.35rem;
    color: ${(p) =>
      p.$checked ? "rgba(197, 201, 207, 0.45)" : "var(--color-grey-800)"};
    text-shadow: ${(p) =>
      p.$checked ? "none" : "0 0 0.6rem rgba(216, 205, 141, 0.7)"};
  }

  .track::after {
    content: "%";
    right: 1.05rem;
    color: ${(p) =>
      p.$checked ? "var(--color-grey-800)" : "rgba(180, 190, 205, 0.45)"};
    text-shadow: ${(p) =>
      p.$checked ? "0 0 0.6rem rgba(141, 194, 211, 0.75)" : "none"};
  }

  .thumb {
    position: absolute;
    top: 0.35rem;
    left: 0.35rem;
    width: 2.9rem;
    height: 2.9rem;
    border-radius: 999px;
    z-index: 1;
    background: linear-gradient(
      145deg,
      rgba(180, 190, 205, 0.95),
      rgba(80, 88, 105, 0.95)
    );
    box-shadow:
      0 0.25rem 0.55rem rgba(0, 0, 0, 0.55),
      inset 0 0.1rem 0.15rem rgba(255, 255, 255, 0.35),
      inset 0 -0.15rem 0.25rem rgba(0, 0, 0, 0.35);
    transition: transform 0.25s ease;
  }

  input:checked ~ .track .thumb {
    transform: translateX(3.8rem);
  }
`;


const menuItems = [
  {
    key: "ViewA",
    label: "Sum Occupied",
    dateMode: "datePicker",
    dataSource: "history",
    component: SumOccupiedByHeight,
  },
  { key: "ViewB", label: "Spectrum", dateMode: null, dataSource: "spectrum", component: WeeklySpectrum },
  { key: "ViewC", label: "Candlestick", dateMode: null, component: PreviewTeaser },
];



function Machine({ machineId, machineKey }) {
  const [searchParms, setSearchParams] = useSearchParams();
  const [menuOpen, setMenuOpen] = useState(false);
  const [range, setRange] = useState({ from: undefined, to: undefined });
  const [isPickerOpen, setPickerOpen] = useState(false);

  const viewKey = `view${machineKey}`;
  const rotKey = `rot${machineKey}`;
  const fromKey = `from${machineKey}`;
  const toKey = `to${machineKey}`;
  const valueModeKey = `valueMode${machineKey}`;


  const isRotating = searchParms.get(rotKey) === "true";
  const seq = searchParms.get("seq") ?? "0";

  const valueMode = searchParms.get(valueModeKey) === "pct" ? "pct" : "raw";
  const isPercentMode = valueMode === "pct";

const setvaluemode = (nextmode) => {
  setSearchParams((prev) => {
    const next = new URLSearchParams(prev);
    next.set(valueModeKey, nextmode);
    return next; // Must return the modified URLSearchParams object
  });
};  
  

const seqNumber = parseInt(seq ?? "0", 10);

const selectedItem = useMemo(() => {
  if (isRotating) {
    const index = seqNumber % menuItems.length;
    return menuItems[index];
  }

  return (
    menuItems.find((item) => item.key === searchParms.get(viewKey)) ||
    menuItems[0]
  );
}, [isRotating, seqNumber, searchParms, viewKey]);

  const activeDataSource = selectedItem.dataSource ?? "history";

  const isValidDate = (value) => {
    if (!value) return false;
    const date = new Date(value);
    return !Number.isNaN(date.getTime());
  };

  const getRollingWeekRange = () => {
    const to = new Date();

    // Stabilize rolling range:
    // seconds = 0
    // milliseconds = 0
    to.setSeconds(0, 0);

    const from = new Date(to);
    from.setDate(to.getDate() - 7);

    return {
      fromIso: from.toISOString(),
      toIso: to.toISOString(),
    };
  };

  const ensureValidRange = (next) => {
    const currentFrom = next.get(fromKey);
    const currentTo = next.get(toKey);

    if (isValidDate(currentFrom) && isValidDate(currentTo)) {
      return next;
    }

    const { fromIso, toIso } = getRollingWeekRange();
    next.set(fromKey, fromIso);
    next.set(toKey, toIso);

    return next;
  };



const rawFrom = searchParms.get(fromKey);
const rawTo = searchParms.get(toKey);

const rollingDates = useMemo(() => {
  const to = new Date();

  // Stable to minute precision
  to.setSeconds(0, 0);

  const from = new Date(to);
  from.setDate(to.getDate() - 7);

  return {
    fromDate: from,
    toDate: to,
  };
}, [seq]);

const manualDates = useMemo(() => {
  return {
    fromDate: isValidDate(rawFrom) ? new Date(rawFrom) : null,
    toDate: isValidDate(rawTo) ? new Date(rawTo) : null,
  };
}, [rawFrom, rawTo]);

const { fromDate, toDate } = isRotating ? rollingDates : manualDates;


  // ✅ UI display
  const formatDate = (date) =>
    date?.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
    });

  const displayText =
    range?.from && range?.to
      ? `${formatDate(range.from)} → ${formatDate(range.to)}`
      : "Select range";

  // ✅ range → URL
  useEffect(() => {
    if (isRotating) return;
    if (!range?.from || !range?.to) return;

    const currentFrom = searchParms.get(fromKey);
    const currentTo = searchParms.get(toKey);

    const nextFrom = range.from.toISOString();
    const nextTo = range.to.toISOString();

    if (currentFrom === nextFrom && currentTo === nextTo) return;

    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set(fromKey, nextFrom);
      next.set(toKey, nextTo);
      return next;
    });
  }, [range, searchParms, setSearchParams, fromKey, toKey, isRotating]);

  // ✅ init default range
  useEffect(() => {
    const currentFrom = searchParms.get(fromKey);
    const currentTo = searchParms.get(toKey);

    if (isValidDate(currentFrom) && isValidDate(currentTo)) return;

    const { fromIso, toIso } = getRollingWeekRange();

    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set(fromKey, fromIso);
      next.set(toKey, toIso);
      return next;
    });
  }, [searchParms, setSearchParams, fromKey, toKey]);

  // ✅ URL → range
  useEffect(() => {
    const from = searchParms.get(fromKey);
    const to = searchParms.get(toKey);

    if (!from || !to) return;

    setRange({
      from: new Date(from),
      to: new Date(to),
    });
  }, [searchParms, fromKey, toKey]);

  const togglePicker = () => setPickerOpen(!isPickerOpen);


  const historyQuery = useGetDispatchHistory(
    fromDate,
    toDate,
    machineId,
    activeDataSource === "history"
  );

  const spectrumQuery = useGetDispatchSpectrum(
    toDate,
    selectedItem.weekSequence ?? 10,
    machineId,
    activeDataSource === "spectrum"
  );

  const activeQuery = useMemo(() => {
    switch (activeDataSource) {
      case "spectrum":
        return spectrumQuery;

      case "history":
        return historyQuery;

      case "none":
      default:
        return {
          data: null,
          isLoading: false,
          error: null,
        };
    }
  }, [activeDataSource, historyQuery, spectrumQuery]);

  return (
    <ContainerMain>
      {/* Date picker */}
      {selectedItem.dateMode && !isRotating && (
        <DataModeWeek>
          <StyledDateRange onClick={togglePicker}>
            {displayText}
          </StyledDateRange>

          {isPickerOpen && (
            <PickerModal>
              <CustomPickerStyles>
                <DayPicker
                  mode="range"
                  selected={range}
                  onSelect={(selectedRange) => {
                    setRange(selectedRange);

                    if (selectedRange?.from && selectedRange?.to) {
                      togglePicker();
                    }
                  }}
                />
              </CustomPickerStyles>
            </PickerModal>
          )}
        </DataModeWeek>
      )}
      {isRotating && (
        <AutoRotateIndicator
          onClick={() => {
            setSearchParams((prev) => {
              const next = new URLSearchParams(prev);

              const { from, to } = rollingDates();

              next.set(rotKey, "false");
              next.set(fromKey, from.toISOString());
              next.set(toKey, to.toISOString());

              // Also persist the currently visible view
              next.set(viewKey, selectedItem.key);

              return next;
            });
          }}
        >
          AUTO
        </AutoRotateIndicator>
      )}

      <ValueModeToggleWrapper>
        <ValueModeToggle
          $checked={isPercentMode}
          title="Toggle raw / percentage"
        >
          <input
            type="checkbox"
            checked={isPercentMode}
            onChange={(e) => {
              setvaluemode(e.target.checked ? "pct" : "raw");
            }}
          />
          <div className="track">
            <div className="thumb" />
          </div>
        </ValueModeToggle>
      </ValueModeToggleWrapper>

      {/* Menu */}
      <MenuButton onClick={() => setMenuOpen(!menuOpen)}>☰</MenuButton>

      {menuOpen && (
        <Drawer open={menuOpen}>
          {menuItems.map((item) => (
            <DrawerItem
              key={item.key}
              onClick={() => {
                setSearchParams((prev) => {
                  const next = new URLSearchParams(prev);
                  next.set(viewKey, item.key);
                  return next;
                });
                setMenuOpen(false);
              }}
            >
              {item.label}
            </DrawerItem>
          ))}

          <hr />

          <DrawerLabel>
            <input
              type="checkbox"
              checked={searchParms.get(rotKey) === "true"}
              onChange={(e) => {
                setSearchParams((prev) => {
                  const next = new URLSearchParams(prev);
                  const checked = e.target.checked;

                  next.set(rotKey, checked.toString());

                  if (checked) {
                    const { fromIso, toIso } = getRollingWeekRange();
                    next.set(fromKey, fromIso);
                    next.set(toKey, toIso);
                  } else {
                    ensureValidRange(next);
                  }

                  return next;
                });

                setMenuOpen(false);
              }}
            />
            Rotate
          </DrawerLabel>
        </Drawer>
      )}

      <StyledHeading>
        Dispatch {machineId} - {selectedItem.label}
      </StyledHeading>

      {selectedItem && (
        <selectedItem.component
          dataset={activeQuery.data}
          isLoading={activeQuery.isLoading}
          error={activeQuery.error}
          machineId={machineId}
          valueMode={valueMode}
        />
      )}
    </ContainerMain>
  );
}

export default Machine;
